import React, {Component} from 'react';
import DefaultModal from "../invoice/DefaultModal";
import moment from "moment/moment";
import Datetime from "react-datetime";
import 'react-datetime/css/react-datetime.css'
import {Col, FormGroup, Label, Row} from "reactstrap";
import {showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";


class CreditMovementModal extends Component {

	constructor(props) {
		super(props);
		this.state ={
		    loading:false,
            baslangicTarihi:null,
            bitisTarihi:null
		};
        this.exportXls     = this.exportXls.bind(this);
	}

    onChangeDate(momentObj, type, fieldValue) {
        let value;
        if (!(typeof momentObj === "string")) {

            if (type === "date") {
                value = momentObj.format("YYYY-MM-DD");
            } else if (type === "datetime") {
                value = momentObj.format("YYYY-MM-DD HH:mm:ss");
            } else if (type === "month") {
                value = momentObj.format("YYYY-MM");
            }
        } else {
            value = momentObj;
            if(type=== "datetime" && moment(value,"DD-MM-YYYY",true).isValid()){
                value = moment(value,"DD-MM-YYYY",true).format("YYYY-MM-DD HH:mm:ss");
            }
        }
        this.setState({[fieldValue]:value});
    }

    async exportXls() {
        this.setState({buttonStyle: 'fas fa-spinner fa-spin'});
        let self = this;
        let params = {
            url: '/credit/getCreditMovementsXls', //TODO: self
            method: "post",
            responseType: 'arraybuffer',
            data: {
                baslangicTarihi:self.state.baslangicTarihi,
                bitisTarihi:self.state.bitisTarihi
            }
        };
        self.setState({confirmBtnDisabled: true});
        await request(params).then(function (response) {
            let blob = new Blob([response.data], {type: response.headers["content-type"]});
            let urlCreator = window.URL || window.webkitURL;
            let url = urlCreator.createObjectURL(blob);
            let a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download =  "kontor_hareketleri_"+self.state.baslangicTarihi+"_"+self.state.bitisTarihi+".xlsx";
            a.click();
            self.setState({buttonStyle: null, confirmBtnDisabled:false});
        }).catch(function (error) {
            self.setState({buttonStyle: null, confirmBtnDisabled:false});
            showAxiosError(error);
        });
    }

	render() {
		return (
			<DefaultModal disabled={this.state.confirmBtnDisabled}
						  isOpen={this.props.modal}
                          size="md"
						  title={this.props.title || ""}
                          confirmBtnText="Excel'e Aktar"
                          cancelBtnText="Kapat"
                          onConfirm={this.exportXls}
						  onCancel={()=>this.props.toggleModal(false)}
			>
                <Row className="col-sm-12" style={{position:"unset", margin:0, paddingTop:"4px", paddingBottom:"8px"}}>
                    <Col md={12}>
                        <FormGroup>
                            <Label for="odemeTuru">Başlangıç Tarihi:</Label>
                            <Datetime locale="tr"
                                      className="datepicker"
                                      input={true}
                                      closeOnSelect={true}
                                      value={moment(this.state.baslangicTarihi, "YYYY-MM-DD", true).isValid() ? moment(this.state.baslangicTarihi).format("DD-MM-YYYY") : this.state.baslangicTarihi}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat={false}
                                      onChange={(e) => this.onChangeDate(e, "date", "baslangicTarihi")}/>
                        </FormGroup>
                    </Col>
                    <Col md={12}>
                        <FormGroup>
                            <Label for="odemeTuru">Bitiş Tarihi:</Label>
                            <Datetime locale="tr"
                                      className="datepicker"
                                      input={true}
                                      closeOnSelect={true}
                                      value={moment(this.state.bitisTarihi, "YYYY-MM-DD", true).isValid() ? moment(this.state.bitisTarihi).format("DD-MM-YYYY") : this.state.bitisTarihi}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat={false}
                                        onChange={(e) => this.onChangeDate(e, "date", "bitisTarihi")}/>
                        </FormGroup>
                    </Col>
                </Row>
			</DefaultModal>
		)
	}
}

export default CreditMovementModal;